import { formatTimeDisplay } from '@peles/shared';
import type { QuestionnaireAnswerValue, QuestionnaireQuestionType } from '@peles/shared';

/** Human-readable rendering of an answer value, by question type. */
export function formatAnswerValue(
  questionType: QuestionnaireQuestionType,
  value: QuestionnaireAnswerValue | null | undefined,
  vendorBusinessName?: string | null,
): string {
  if (!value) return '';
  switch (questionType) {
    case 'YES_NO':
      return value.bool === undefined ? '' : value.bool ? 'Yes' : 'No';
    case 'NUMBER':
      return value.number != null ? String(value.number) : '';
    case 'SINGLE_CHOICE':
      if (value.choice === '__other__') return value.otherText ? `Other: ${value.otherText}` : '';
      return value.choice ?? '';
    case 'TIME':
      // 12-hour AM/PM display, matching the timeline views.
      return formatTimeDisplay(value.time);
    case 'DATE':
      return value.date ?? '';
    case 'CONTACT':
      return [value.contactName, value.contactPhone].filter(Boolean).join(' · ');
    case 'VENDOR':
      return vendorBusinessName || value.vendorName || '';
    default:
      return value.text ?? '';
  }
}

/** True when the answer carries any content. */
export function hasAnswerValue(value: QuestionnaireAnswerValue | null | undefined): boolean {
  if (!value) return false;
  return Object.values(value).some((v) => v !== null && v !== undefined && v !== '');
}
